import BlaBlaCar from 'marketing-website/components/icons/BlaBlaCar';
import Typeform from 'marketing-website/components/icons/Typeform';
import Monzo from 'marketing-website/components/icons/Monzo';
import Stripe from 'marketing-website/components/icons/Stripe';

const requestQuotesLogos = [
  {
    id: 'Typeform',
    logo: Typeform,
  },
  {
    id: 'monzo',
    logo: Monzo,
  },
  {
    id: 'blablacar',
    logo: BlaBlaCar,
  },
  {
    id: 'stripe',
    logo: Stripe,
  },
];

export default requestQuotesLogos;



// WEBPACK FOOTER //
// ./src/configs/pages/enterprise/requestQuotesLogos.js